export const BASE_API_URL = process.env.REACT_APP_API_URL;

export const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_URL_S3;

export const TEST_BASE_IMAGE_URL = process.env.REACT_APP_TEST_IMAGE_URL_S3;
